import React from 'react';
import {Box, Button, Stack, Typography} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import {StyleSx, Sx} from 'app/types/common';
import {packSx} from 'app/util/packSx/packSx';
import {router} from 'app/router/main';

const rootSx: StyleSx = {borderRadius: 1, py: 6, pl: 9, minHeight: 400};

interface Props extends Sx {
  logo: React.ReactNode;
  title: string;
  description: string;
  paymentAccess: boolean;
}

export default function FeatureLockNotice({sx, logo, title, description, paymentAccess}: Props) {
  return (
    <Box sx={packSx(rootSx, sx)}>
      <Box mb={4}>{logo}</Box>

      <Stack direction="row" alignItems="center" gap={1}>
        <LockIcon color="error" fontSize="medium" />

        <Typography variant="h5" fontWeight={600}>
          {title}
        </Typography>
      </Stack>

      <Typography mt={1} maxWidth={430} fontSize={18} color="text.secondary">
        {description}
      </Typography>

      {paymentAccess && (
        <Button
          sx={{mt: 4}}
          variant="contained"
          color="secondary"
          onClick={() => router.go('settingBillingUsage')}
        >
          Update payment
        </Button>
      )}
    </Box>
  );
}
